import { render, staticRenderFns } from "./AddEditPurchaseModal.vue?vue&type=template&id=0b88209d&scoped=true"
import script from "./AddEditPurchaseModal.vue?vue&type=script&lang=js"
export * from "./AddEditPurchaseModal.vue?vue&type=script&lang=js"
import style0 from "./AddEditPurchaseModal.vue?vue&type=style&index=0&id=0b88209d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b88209d",
  null
  
)

export default component.exports